import {Property} from "../flow/loan-details/model/Property";

export class AddressUtil {
    public static toString(property: Property): string {
        return `${property.street} ${property.city} ${property.state}, ${property.zipCode}`
    }
}